export const BILLING_REPORT_SLUG = 'billing-report'

export const INTERNAL_REPORTS = [
  {
    id: BILLING_REPORT_SLUG,
    slug: BILLING_REPORT_SLUG,
    name: 'Billing Report',
    description:
      'This report shows what equipment is assigned to each site.',
  },
]
